import { computed, type Ref } from 'vue';

import ordersService from '@exchange/libs/order/my-orders/service/src/lib/orders.service';

export function useFutures(marketId?: Ref<string>, showAllMarkets?: Ref<boolean>) {
  const futuresPositions = computed(() => Object.values(ordersService.reactivePerpsData.value));

  const getFuturesPositions = computed(() => {
    let filteredPositions = futuresPositions.value;

    if (!showAllMarkets?.value && marketId?.value) {
      filteredPositions = filteredPositions.filter((item) => item.instrument_code === marketId.value);
    }

    return filteredPositions;
  });

  return {
    getFuturesPositions,
  };
}
